import { useQuery } from 'react-query';

import { AlertType, AlertsEntityType, QueryKey } from '@ge/models/constants';
import { delay } from '@ge/shared/util';

import { Config } from './config';

export const useAlertTypes = ({ entityType, isActive = true }) => {
  const { data, error, isLoading } = useQuery(
    [QueryKey.ALERT_TYPES, entityType],
    // TODO: get these template types from backend
    () =>
      delay(() => {
        switch (entityType) {
          case AlertsEntityType.SITE:
            return [
              AlertType.NOTAM,
              AlertType.PLANNED_OUTAGE,
              AlertType.UNPLANNED_OUTAGE,
              AlertType.COMMISSIONING_OUTAGE,
              AlertType.RELIABILITY_RUN,
              AlertType.CONTRACT_END_OUTAGE,
              AlertType.DERATE
            ];
          case AlertsEntityType.WIND_TURBINE:
            return Object.values(AlertType).filter(type => type != AlertType.DERATE);
          case AlertsEntityType.SUBSTATION:
          case AlertsEntityType.WIND_SITE_CONTROLLER:
            return [AlertType.PLANNED_OUTAGE, AlertType.UNPLANNED_OUTAGE, AlertType.NOCOMM_OUTAGE, AlertType.CONTRACT_END_OUTAGE];
          case AlertsEntityType.INVERTER:
            return [AlertType.PLANNED_OUTAGE, AlertType.UNPLANNED_OUTAGE, AlertType.CONTRACT_END_OUTAGE];
          case AlertsEntityType.STORAGE_SITE:
            return [AlertType.PLANNED_OUTAGE, AlertType.UNPLANNED_OUTAGE, AlertType.CONTRACT_END_OUTAGE, AlertType.DERATE];
          case AlertsEntityType.SOLAR_SITE:
            return [AlertType.PLANNED_OUTAGE, AlertType.UNPLANNED_OUTAGE, AlertType.CONTRACT_END_OUTAGE, AlertType.DERATE];
          default:
            return [];
        }
      }, 500),
    {
      ...Config.EXECUTE_ONCE,
      enabled: isActive,
    },
  );

  return { data, error, isLoading };
};
